import constants from 'constants';

const {
  LOGIN_SAGA,
  LOGOUT_SAGA,
  PERFORM_LOGOUT,
  FORGOT_PASSWORD_SAGA,
  NEW_PASSWORD_SAGA,
  CHANGE_PASSWORD_SAGA
} = constants;

const performLogout = () => {
  return {
    type: PERFORM_LOGOUT
  }
}

const logout = () => ({
  type: LOGOUT_SAGA
})

const login = (email, password) => {
  return {
    type: LOGIN_SAGA,
    email,
    password
  }
}

const forgotPasswordSaga = (email) => ({
  type: FORGOT_PASSWORD_SAGA,
  email
});

const newPasswordSaga = (user) => ({
  type: NEW_PASSWORD_SAGA,
  user
});

const changePasswordSaga = (user) => ({
  type: CHANGE_PASSWORD_SAGA,
  user
});

export {
  login,
  logout,
  performLogout,
  forgotPasswordSaga,
  newPasswordSaga,
  changePasswordSaga
};



/** WEBPACK FOOTER **
 ** ./src/actions/auth.js
 **/